"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_1 = require("../../index");
const Checkbox = ({ checked, indeterminate, onChange, id, label, truncated = false, disabled = false, hoverButton, helperText, onBlur, name, value, }) => {
    const className = classnames_1.default({
        'checkbox-disabled-label': disabled,
        'checkbox-truncated-label': truncated,
    });
    return (React.createElement("div", { className: "child-checkbox-wrapper" },
        React.createElement("input", { type: "checkbox", className: "styled-checkbox", onChange: onChange, onBlur: onBlur, name: name, value: value, id: id, disabled: disabled, ref: (input) => {
                if (input) {
                    input.checked = checked;
                    // if both checked and indeterminate are true, checked trumps indeterminate
                    input.indeterminate = indeterminate ? input.checked ? false : indeterminate : false;
                }
            } }),
        React.createElement("label", { htmlFor: id, className: className }, helperText ? React.createElement("div", null,
            React.createElement("span", { className: className }, label),
            React.createElement("div", { className: "checkbox-helper-text" }, helperText)) :
            React.createElement("span", { className: className }, label)),
        hoverButton && React.createElement(index_1.Button, { size: "xs", onClick: hoverButton.action }, hoverButton.label)));
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map